import React, { useEffect, useCallback, useState} from 'react';
import LookConfig from './LookConfig.js';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';

const MAIN = 'MAIN';
const LOOK = 'LOOK';
const PlaneConfig = ({effect, sequencerEngine, hideUI, setHideUI}) => { 
    const [mode, setMode] = useState(MAIN);
    return (
        <div className="plane-config">
          {mode === MAIN && <MainConfig effect={effect} sequencerEngine={sequencerEngine}/>}
          {mode === LOOK && <LookConfig effect={effect} sequencerEngine={sequencerEngine}/>}
        {/*<div className="tab-options">
            <Tab mode={mode} setMode={setMode} type={MAIN} name="Main"/>
            <Tab mode={mode} setMode={setMode} type={LOOK} name="Look"/>

            </div>*/}
          <div className="tab-options">
            <HideUI hideUI={hideUI} setHideUI={setHideUI}/>
          </div>
        </div>);
};

const HideUI = ({hideUI, setHideUI}) => {
    let className = "hide-ui-toggle";
    if (hideUI) {
        className += " hiding";
    }
    return (
        <div onClick={() => setHideUI(!hideUI)} className={className}>
          {hideUI && <div className="circle-button"></div>}
          {hideUI ? "No UI" : "UI"}
          {!hideUI && <div className="circle-button"></div>}
        </div>
    );
};

const Tab  = ({mode, setMode, type, name}) => {
    let className = "tab-option";
    if (type === mode) {
        className += " selected";
    }
    return (
        <div onClick={() => setMode(type)} className={className}>
          {name}
        </div>);
};

const MainConfig = ({effect, sequencerEngine}) => {
    return (
        <div className="config-parameters">
          <EffectParameterSlider
            name="Ramp Time"
            unit="ms"
            parameter={effect.rampTimeParameter}
            min={1}
            max={2000}
            step={1}
            lfoEnabled={true}
            isParameter={true}
            sequencerEngine={sequencerEngine}
          />
          <EffectParameterSlider
            name="# Parameters per iter"
            unit="ms"
            parameter={effect.maxParametersParameter}
            min={16}
            max={64}
            step={1}
            lfoEnabled={true}
            isParameter={true}
            sequencerEngine={sequencerEngine}
          />
          <EffectParameterSlider
            name="Update Rate"
            unit=""
            parameter={effect.updateRateParameter}
            min={0}
            max={8}
            step={1}
            lfoEnabled={true}
            isParameter={true}
            sequencerEngine={sequencerEngine}
          />
       </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneConfig);
